import React, { Component } from 'react'
import './ComponentsCommon.scss'
import FieldTypes from './FieldTypes'

export default class Radiolist extends Component {

    constructor(props) {
        super(props)

        this.state = {
            fieldModel: this.props.model,
            fieldEvents: this.props.events,
            value: this.props.value,
            options: []
        }
    }

    componentDidMount() {
        let { model } = this.props
        if (model.options) {
            this.setState({
                options: this.state.options.concat(model.options)
            })
        }
    }

    render() {

        const { fieldModel, fieldEvents, options } = this.state
        const { value } = this.props

        return (
            <div className="radio-group">
                {
                    options.map((item, idx) => (
                        <div className="radio-option">
                            <input
                                onClick={fieldEvents.onChange}
                                checked={value === item.id ? true : false}
                                className='radio-input'
                                type="radio"
                                id={item.id}
                                name={fieldModel.name}
                                value={item.id}
                                fieldtype={FieldTypes.radiolist}
                            />
                            <label className='radio-label' for={item.id}>{item.label}</label>
                        </div>
                    ))
                }
            </div>
        )
    }
}
